/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Api
 * API specification for Паруса на крыше restaurant
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ApiError,
  BanquetRequest,
  BanquetRequestInput,
  Booking,
  BookingInput,
  Event,
  GetEventsParams,
  GetMenuItemsParams,
  HealthStatus,
  MenuItem,
  Review
} from './api.schemas';

import { customFetch } from '../custom-fetch';
import type { ErrorType , BodyType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getGetPublicAssetUrl = (filePath: string,) => {




  return `/api/storage/public-objects/${filePath}`
}

/**
 * @summary Serve a public restaurant asset from App Storage
 */
export const getPublicAsset = async (filePath: string, options?: RequestInit): Promise<Blob> => {

  return customFetch<Blob>(getGetPublicAssetUrl(filePath),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPublicAssetQueryKey = (filePath: string,) => {
    return [
    `/api/storage/public-objects/${filePath}`
    ] as const;
    }


export const getGetPublicAssetQueryOptions = <TData = Awaited<ReturnType<typeof getPublicAsset>>, TError = ErrorType<ApiError>>(filePath: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPublicAsset>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicAssetQueryKey(filePath);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicAsset>>> = ({ signal }) => getPublicAsset(filePath, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(filePath), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicAsset>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPublicAssetQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicAsset>>>
export type GetPublicAssetQueryError = ErrorType<ApiError>


/**
 * @summary Serve a public restaurant asset from App Storage
 */

export function useGetPublicAsset<TData = Awaited<ReturnType<typeof getPublicAsset>>, TError = ErrorType<ApiError>>(
 filePath: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPublicAsset>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPublicAssetQueryOptions(filePath,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getHealthCheckUrl = () => {




  return `/api/healthz`
}

/**
 * Returns server health status
 * @summary Health check
 */
export const healthCheck = async ( options?: RequestInit): Promise<HealthStatus> => {

  return customFetch<HealthStatus>(getHealthCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthCheckQueryKey = () => {
    return [
    `/api/healthz`
    ] as const;
    }


export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = ErrorType<unknown>


/**
 * @summary Health check
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateBookingUrl = () => {




  return `/api/bookings`
}

/**
 * @summary Create a table booking request
 */
export const createBooking = async (bookingInput: BookingInput, options?: RequestInit): Promise<Booking> => {

  return customFetch<Booking>(getCreateBookingUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      bookingInput,)
  }
);}




export const getCreateBookingMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBooking>>, TError,{data: BodyType<BookingInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createBooking>>, TError,{data: BodyType<BookingInput>}, TContext> => {

const mutationKey = ['createBooking'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBooking>>, {data: BodyType<BookingInput>}> = (props) => {
          const {data} = props ?? {};

          return  createBooking(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateBookingMutationResult = NonNullable<Awaited<ReturnType<typeof createBooking>>>
    export type CreateBookingMutationBody = BodyType<BookingInput>
    export type CreateBookingMutationError = ErrorType<ApiError>

    /**
 * @summary Create a table booking request
 */
export const useCreateBooking = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBooking>>, TError,{data: BodyType<BookingInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createBooking>>,
        TError,
        {data: BodyType<BookingInput>},
        TContext
      > => {
      return useMutation(getCreateBookingMutationOptions(options));
    }

export const getCreateBanquetRequestUrl = () => {




  return `/api/banquet-requests`
}

/**
 * @summary Create a banquet request
 */
export const createBanquetRequest = async (banquetRequestInput: BanquetRequestInput, options?: RequestInit): Promise<BanquetRequest> => {

  return customFetch<BanquetRequest>(getCreateBanquetRequestUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      banquetRequestInput,)
  }
);}




export const getCreateBanquetRequestMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBanquetRequest>>, TError,{data: BodyType<BanquetRequestInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createBanquetRequest>>, TError,{data: BodyType<BanquetRequestInput>}, TContext> => {

const mutationKey = ['createBanquetRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBanquetRequest>>, {data: BodyType<BanquetRequestInput>}> = (props) => {
          const {data} = props ?? {};

          return  createBanquetRequest(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateBanquetRequestMutationResult = NonNullable<Awaited<ReturnType<typeof createBanquetRequest>>>
    export type CreateBanquetRequestMutationBody = BodyType<BanquetRequestInput>
    export type CreateBanquetRequestMutationError = ErrorType<ApiError>

    /**
 * @summary Create a banquet request
 */
export const useCreateBanquetRequest = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBanquetRequest>>, TError,{data: BodyType<BanquetRequestInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createBanquetRequest>>,
        TError,
        {data: BodyType<BanquetRequestInput>},
        TContext
      > => {
      return useMutation(getCreateBanquetRequestMutationOptions(options));
    }

export const getGetEventsUrl = (params?: GetEventsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/events?${stringifiedParams}` : `/api/events`
}

/**
 * @summary Get all events
 */
export const getEvents = async (params?: GetEventsParams, options?: RequestInit): Promise<Event[]> => {

  return customFetch<Event[]>(getGetEventsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEventsQueryKey = (params?: GetEventsParams,) => {
    return [
    `/api/events`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetEventsQueryOptions = <TData = Awaited<ReturnType<typeof getEvents>>, TError = ErrorType<unknown>>(params?: GetEventsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEvents>>> = ({ signal }) => getEvents(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEventsQueryResult = NonNullable<Awaited<ReturnType<typeof getEvents>>>
export type GetEventsQueryError = ErrorType<unknown>


/**
 * @summary Get all events
 */

export function useGetEvents<TData = Awaited<ReturnType<typeof getEvents>>, TError = ErrorType<unknown>>(
 params?: GetEventsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEventsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetUpcomingEventsUrl = () => {




  return `/api/events/upcoming`
}

/**
 * @summary Get upcoming events (max 3)
 */
export const getUpcomingEvents = async ( options?: RequestInit): Promise<Event[]> => {

  return customFetch<Event[]>(getGetUpcomingEventsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetUpcomingEventsQueryKey = () => {
    return [
    `/api/events/upcoming`
    ] as const;
    }


export const getGetUpcomingEventsQueryOptions = <TData = Awaited<ReturnType<typeof getUpcomingEvents>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUpcomingEvents>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUpcomingEventsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUpcomingEvents>>> = ({ signal }) => getUpcomingEvents({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUpcomingEvents>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUpcomingEventsQueryResult = NonNullable<Awaited<ReturnType<typeof getUpcomingEvents>>>
export type GetUpcomingEventsQueryError = ErrorType<unknown>


/**
 * @summary Get upcoming events (max 3)
 */

export function useGetUpcomingEvents<TData = Awaited<ReturnType<typeof getUpcomingEvents>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUpcomingEvents>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUpcomingEventsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetReviewsUrl = () => {




  return `/api/reviews`
}

/**
 * @summary Get customer reviews
 */
export const getReviews = async ( options?: RequestInit): Promise<Review[]> => {

  return customFetch<Review[]>(getGetReviewsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetReviewsQueryKey = () => {
    return [
    `/api/reviews`
    ] as const;
    }


export const getGetReviewsQueryOptions = <TData = Awaited<ReturnType<typeof getReviews>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getReviews>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReviewsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReviews>>> = ({ signal }) => getReviews({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReviews>>, TError, TData> & { queryKey: QueryKey }
}

export type GetReviewsQueryResult = NonNullable<Awaited<ReturnType<typeof getReviews>>>
export type GetReviewsQueryError = ErrorType<unknown>


/**
 * @summary Get customer reviews
 */

export function useGetReviews<TData = Awaited<ReturnType<typeof getReviews>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getReviews>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetReviewsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetMenuItemsUrl = (params?: GetMenuItemsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/menu-items?${stringifiedParams}` : `/api/menu-items`
}

/**
 * @summary Get menu items, optionally by category
 */
export const getMenuItems = async (params?: GetMenuItemsParams, options?: RequestInit): Promise<MenuItem[]> => {

  return customFetch<MenuItem[]>(getGetMenuItemsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMenuItemsQueryKey = (params?: GetMenuItemsParams,) => {
    return [
    `/api/menu-items`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMenuItemsQueryOptions = <TData = Awaited<ReturnType<typeof getMenuItems>>, TError = ErrorType<unknown>>(params?: GetMenuItemsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMenuItems>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMenuItemsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMenuItems>>> = ({ signal }) => getMenuItems(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMenuItems>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMenuItemsQueryResult = NonNullable<Awaited<ReturnType<typeof getMenuItems>>>
export type GetMenuItemsQueryError = ErrorType<unknown>


/**
 * @summary Get menu items, optionally by category
 */

export function useGetMenuItems<TData = Awaited<ReturnType<typeof getMenuItems>>, TError = ErrorType<unknown>>(
 params?: GetMenuItemsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMenuItems>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMenuItemsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







